<template>
<div class="step-qna agent-questions-section">
  <section>
    <div class="d-flex justify-content-center">
      <h4 class="center">Are you currently working with, or have you signed documentation<br/> with a real estate agent?</h4>    
    </div>
    <div class="d-flex justify-content-center">
      <div class="h-buttons">
        <b-button 
          class="button yes-no" 
          :class="[{'active': withAgentQuestion === true}]" 
          pill 
          variant="outline-secondary" 
          :pressed="withAgentQuestion === true"
          @click="updateWithAgentQuestion(true)">Yes
        </b-button>
        <b-button 
          class="button yes-no" 
          :class="[{'active': withAgentQuestion === false}]" 
          pill 
          variant="outline-secondary" 
          :pressed="withAgentQuestion === false"
          @click="updateWithAgentQuestion(false)"
        >
          No
        </b-button>
      </div>
    </div>
  </section>
  <div v-if="withAgentQuestion === true"> 
    <section>
      <div class="contain m-auto justify-content-center">
        <b-form-group
          id="fieldset-1"
          description=""
          label="Your Agent's full name"
          label-for="full-name"
        >
          <b-form-input 
            id="full-name" 
            v-model="agentInfo.fullName" lazy
            aria-describedby="input-live-help input-live-feedback"
            @blur="updateAgentFullName()" required trim
            :state="this.isElementValid($v.agentInfo.fullName)"
          ></b-form-input>
          <b-form-invalid-feedback id="input-live-feedback">
              Please enter a full name
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="fieldset-3"
          description=""
          label="Your Agent's email"
          label-for="email"
        >
          <b-form-input id="email" v-model="agentInfo.email" lazy
          @blur="updateAgentEmail()" trim
          :state="this.isElementValid($v.agentInfo.email)"
          ></b-form-input>

          <b-form-invalid-feedback id="input-live-feedback">
          Enter your agent's email address (john@example.com)
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="fieldset-3"
          description=""
          label="Your Agent's phone number"
          label-for="phone"
        >
          <b-form-input 
            id="phone" 
            v-model="formattedAgentPhone" 
            lazy
            aria-describedby="input-live-help input-live-feedback"
            @blur="updateAgentPhone()" 
            required 
            trim
            :state="this.isElementValid($v.formattedAgentPhone)"
            pattern="[0-9]*"
            inputmode="numeric"
            maxlength="14"
            type="tel"
            v-mask="'(###) ###-####'"
          ></b-form-input>
        </b-form-group>
      </div>
    </section> 
  </div>
</div>
</template>
<script>
import { saveField } from "@/services/apiService";
import { required, minLength, email } from 'vuelidate/lib/validators';
import { mask } from 'vue-the-mask';

export default {
  name: 'AgentInfo',
  directives: { mask },
  data() {
    return {
      agentInfo: {
          fullName: undefined,
          phone: undefined,
          email: undefined
      },
      formattedAgentPhone: '',
      withAgentQuestion: undefined
    }
  },
  validations: {
    agentInfo: {
      fullName: {
          required,
          minLength: minLength(3)
      },
      email: {
          required,
          email
      },
    },
    formattedAgentPhone: {
      required,
      minLength: minLength(14)
    }
  },
  methods: {
      updateWithAgentQuestion: function (value) {
        this.withAgentQuestion = value
        this.onSelectedValue('withAgentQuestion', 'workingOrSignedDoc', value)
        if (value === false) {
          this.$emit('go-to-next-step');
        }
      },
      showMessage: function (message) {
        this.$bvModal.msgBoxOk(message, {centered: true});
      },
      onSelectedValue: function (field, saveAs, value) {
        this.$emit('on-value-entry', { field: field, saveAs: saveAs, value: value });
        saveField(saveAs, value);
      },
      updateAgentFullName: function () {
        this.$v.agentInfo.fullName.$touch();
        if (!this.$v.agentInfo.fullName.$invalid) {
            this.$emit('on-agent-info-update', this.agentInfo);
            saveField('agent_full_name', this.agentInfo.fullName);
        }
      },
      updateAgentPhone: function () {
        this.$v.formattedAgentPhone.$touch();
        this.agentInfo.phone = this.formattedAgentPhone
            .replace('(', '')
            .replace(')', '')
            .replace(' ', '')
            .replace('-', '');
        this.$emit('on-agent-info-update', this.agentInfo);
        if (!this.$v.formattedAgentPhone.$invalid) {
          saveField('agent_phone', this.agentInfo.phone);
        }
      },
      updateAgentEmail: function () {
        this.$v.agentInfo.email.$touch();
        this.$emit('on-agent-info-update', this.agentInfo);
        saveField('agent_email', this.agentInfo.email);
      },
      /**
       * Determines if an element is valid and returns a value used for displaying validation
       * @param vFormElement vuelidate form element
       * @returns {null|boolean} null if the element hasn't been touched, false if it has been touched and fails validation
       * and true if it has been touched and passes validation
       */
      isElementValid: function (vFormElement) {
        if (!vFormElement) {
          return null;
        }
        if (!vFormElement.$dirty) {
          return null;
        }

        if (vFormElement.$invalid) {
          return false;
        }

        if (!vFormElement.$invalid && vFormElement.$dirty) {
          return true;
        }
        return null;
      }

  }
}
</script>